import { all, call, put, takeLatest } from 'redux-saga/effects';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import {
  createBinControlUnit,
  deleteBinControlUnit,
  editBinControlUnit,
  getBinControlunitsList,
  saveBinControlUnitsForm,
} from './binControl.actions';
import { compose403ErrorMessage } from '../../../core/helpers/utils/sagaUtils';
import api from '../../../core/api';
import { LoadersNames } from '../../ui/ui.constants';
import { BinControlUnit } from './binControl.types';

function* getBinControlUnitsListSaga() {
  yield put(showLoader(LoadersNames.getBinControlInits));
  try {
    const result = yield call(api.binControl.getBinControlUnitsList);
    yield put(
      getBinControlunitsList.done({
        result,
      }),
    );
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.getBinControlInits));
}

function* createBinControlUnitsListSaga(action: ReturnType<typeof createBinControlUnit.started>) {
  try {
    const result = yield call(api.binControl.createBinControlUnitsList, action.payload);
    yield put(
      createBinControlUnit.done({
        result,
        params: action.payload,
      }),
    );
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

function* editBinControlUnitsListSaga(action: ReturnType<typeof editBinControlUnit.started>) {
  try {
    const result = yield call(api.binControl.editBinControlUnitsList, action.payload.id!, action.payload);
    yield put(
      editBinControlUnit.done({
        result,
        params: action.payload,
      }),
    );
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

function* deleteBinControlUnitsListSaga(action: ReturnType<typeof deleteBinControlUnit.started>) {
  yield put(showLoader(LoadersNames.getBinControlInits));
  try {
    yield call(api.binControl.deleteBinControlUnitsList, action.payload);
    yield put(
      deleteBinControlUnit.done({
        params: action.payload,
      }),
    );
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.getBinControlInits));
}

function* saveBinControlUnitsFormSaga(action: ReturnType<typeof saveBinControlUnitsForm.started>) {
  yield put(showLoader(LoadersNames.saveBinControlUnitsForm));
  const { updatedBinControlUnits, createdBinControlUnits, deletedBinControlUnits } = action.payload;
  try {
    yield all([
      ...createdBinControlUnits.map((binControl) => {
        return call(api.binControl.createBinControlUnitsList, binControl);
      }),
      ...updatedBinControlUnits.map((binControl) => {
        const payload: Partial<BinControlUnit> = {
          ...binControl,
          channels: binControl.channels.map(({ id, ingredientDescr, location, ...channel }) => channel) as any,
        };
        return call(api.binControl.editBinControlUnitsList, payload.id!, payload);
      }),
      ...deletedBinControlUnits.map((binControl) => {
        return call(api.binControl.deleteBinControlUnitsList, binControl.id);
      }),
    ]);
  } catch (err) {
    yield compose403ErrorMessage(err);
  } finally {
    yield put(getBinControlunitsList.started());
    yield put(hideLoader(LoadersNames.saveBinControlUnitsForm));
  }
}

export function* watBinControlSaga() {
  return yield all([
    yield takeLatest(getBinControlunitsList.started, getBinControlUnitsListSaga),
    yield takeLatest(createBinControlUnit.started, createBinControlUnitsListSaga),
    yield takeLatest(editBinControlUnit.started, editBinControlUnitsListSaga),
    yield takeLatest(deleteBinControlUnit.started, deleteBinControlUnitsListSaga),
    yield takeLatest(saveBinControlUnitsForm.started, saveBinControlUnitsFormSaga),
  ]);
}
